export default {"src":"https://js-static.hirist.tech/production/8.3.1/_next/static/media/cal.5daa8258.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};